/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.1.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const SUBSCRIPTION_API_BASE_URL = new InjectionToken<string>('SUBSCRIPTION_API_BASE_URL');

@Injectable()
export class CustomersApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SUBSCRIPTION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    info() : Observable<Customer> {
        let url_ = this.baseUrl + "/v2/api/subscription/customers/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfo(<any>response_);
                } catch (e) {
                    return <Observable<Customer>><any>_observableThrow(e);
                }
            } else
                return <Observable<Customer>><any>_observableThrow(response_);
        }));
    }

    protected processInfo(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(<any>null);
    }

    /**
     * @return Success
     */
    paymentInfoGet() : Observable<GetPaymentInfoResult> {
        let url_ = this.baseUrl + "/v2/api/subscription/customers/payment-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentInfoGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentInfoGet(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentInfoResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentInfoResult>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentInfoGet(response: HttpResponseBase): Observable<GetPaymentInfoResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentInfoResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentInfoResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    paymentInfoPut(body: CreditCard | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/v2/api/subscription/customers/payment-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentInfoPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentInfoPut(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentInfoPut(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class HealthApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SUBSCRIPTION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    probe() : Observable<void> {
        let url_ = this.baseUrl + "/v2/api/subscription/health/probe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProbe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProbe(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProbe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class MarketingApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SUBSCRIPTION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lead(body: RegisterLeadRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/v2/api/subscription/marketing/lead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLead(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processLead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class OrdersApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SUBSCRIPTION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrderRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/v2/api/subscription/orders/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class SubscriptionApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SUBSCRIPTION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    details() : Observable<GetSubscriptionResponse> {
        let url_ = this.baseUrl + "/v2/api/subscription/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetails(<any>response_);
                } catch (e) {
                    return <Observable<GetSubscriptionResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSubscriptionResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDetails(response: HttpResponseBase): Observable<GetSubscriptionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionResponse>(<any>null);
    }

    /**
     * @return Success
     */
    cancel() : Observable<void> {
        let url_ = this.baseUrl + "/v2/api/subscription/cancel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    abandonCancellation() : Observable<void> {
        let url_ = this.baseUrl + "/v2/api/subscription/abandon-cancellation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbandonCancellation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbandonCancellation(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAbandonCancellation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param edition (optional) 
     * @return Success
     */
    editions(edition: string | undefined) : Observable<EditionsDefinition> {
        let url_ = this.baseUrl + "/v2/api/subscription/editions?";
        if (edition === null)
            throw new Error("The parameter 'edition' cannot be null.");
        else if (edition !== undefined)
            url_ += "edition=" + encodeURIComponent("" + edition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditions(<any>response_);
                } catch (e) {
                    return <Observable<EditionsDefinition>><any>_observableThrow(e);
                }
            } else
                return <Observable<EditionsDefinition>><any>_observableThrow(response_);
        }));
    }

    protected processEditions(response: HttpResponseBase): Observable<EditionsDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsDefinition.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionsDefinition>(<any>null);
    }

    /**
     * @param allItems (optional) 
     * @return Success
     */
    availableAdditionalItems(allItems: boolean | undefined) : Observable<AvailableAdditionalItemSection[]> {
        let url_ = this.baseUrl + "/v2/api/subscription/available-additional-items?";
        if (allItems === null)
            throw new Error("The parameter 'allItems' cannot be null.");
        else if (allItems !== undefined)
            url_ += "allItems=" + encodeURIComponent("" + allItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvailableAdditionalItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvailableAdditionalItems(<any>response_);
                } catch (e) {
                    return <Observable<AvailableAdditionalItemSection[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailableAdditionalItemSection[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvailableAdditionalItems(response: HttpResponseBase): Observable<AvailableAdditionalItemSection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AvailableAdditionalItemSection.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailableAdditionalItemSection[]>([]);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CheckoutRequest | undefined) : Observable<CheckoutResponse> {
        let url_ = this.baseUrl + "/v2/api/subscription/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CheckoutResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckoutResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CheckoutResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckoutResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckoutResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateVoucher(body: ValidateDiscountVoucherRequest | undefined) : Observable<ValidateVoucherResponse> {
        let url_ = this.baseUrl + "/v2/api/subscription/validate-voucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateVoucher(<any>response_);
                } catch (e) {
                    return <Observable<ValidateVoucherResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateVoucherResponse>><any>_observableThrow(response_);
        }));
    }

    protected processValidateVoucher(response: HttpResponseBase): Observable<ValidateVoucherResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateVoucherResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateVoucherResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateLink(body: GeneratePersonalizedLinkRequest | undefined) : Observable<GeneratePersonalizedLinkResponse> {
        let url_ = this.baseUrl + "/v2/api/subscription/generate-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateLink(<any>response_);
                } catch (e) {
                    return <Observable<GeneratePersonalizedLinkResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GeneratePersonalizedLinkResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGenerateLink(response: HttpResponseBase): Observable<GeneratePersonalizedLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeneratePersonalizedLinkResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneratePersonalizedLinkResponse>(<any>null);
    }

    /**
     * @return Success
     */
    subscriptionBillings() : Observable<GetSubscriptionBillingsResponse> {
        let url_ = this.baseUrl + "/v2/api/subscription/subscription-billings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionBillings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionBillings(<any>response_);
                } catch (e) {
                    return <Observable<GetSubscriptionBillingsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetSubscriptionBillingsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSubscriptionBillings(response: HttpResponseBase): Observable<GetSubscriptionBillingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionBillingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionBillingsResponse>(<any>null);
    }

    /**
     * @return Success
     */
    paymentGateway() : Observable<GetPaymentGatewayResponse> {
        let url_ = this.baseUrl + "/v2/api/subscription/payment-gateway";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentGateway(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentGateway(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentGatewayResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentGatewayResponse>><any>_observableThrow(response_);
        }));
    }

    protected processPaymentGateway(response: HttpResponseBase): Observable<GetPaymentGatewayResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentGatewayResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentGatewayResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acquireAditionalItem(body: AcquireAdditionalItemRequest | undefined) : Observable<boolean> {
        let url_ = this.baseUrl + "/v2/api/subscription/acquire-aditional-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcquireAditionalItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcquireAditionalItem(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAcquireAditionalItem(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class WebhooksApi {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SUBSCRIPTION_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param type (optional) 
     * @param body (optional) 
     * @return Success
     */
    log(type: string | undefined, body: any | undefined) : Observable<void> {
        let url_ = this.baseUrl + "/v2/api/subscription/webhooks/log?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLog(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class CreditCardInfo implements ICreditCardInfo {
    flag: string | undefined;
    ownerName: string | undefined;
    digits: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;

    constructor(data?: ICreditCardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"];
            this.ownerName = _data["ownerName"];
            this.digits = _data["digits"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
        }
    }

    static fromJS(data: any): CreditCardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag;
        data["ownerName"] = this.ownerName;
        data["digits"] = this.digits;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        return data; 
    }

    clone(): CreditCardInfo {
        const json = this.toJSON();
        let result = new CreditCardInfo();
        result.init(json);
        return result;
    }
}

export interface ICreditCardInfo {
    flag: string | undefined;
    ownerName: string | undefined;
    digits: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;
}

export class Customer implements ICustomer {
    id: number;
    fiscalIdentifier: string | undefined;
    address: Address;
    paymentMethod: PaymentMethod;
    creditCard: CreditCardInfo;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fiscalIdentifier = _data["fiscalIdentifier"];
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"];
            this.creditCard = _data["creditCard"] ? CreditCardInfo.fromJS(_data["creditCard"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fiscalIdentifier"] = this.fiscalIdentifier;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod;
        data["creditCard"] = this.creditCard ? this.creditCard.toJSON() : <any>undefined;
        return data; 
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    id: number;
    fiscalIdentifier: string | undefined;
    address: Address;
    paymentMethod: PaymentMethod;
    creditCard: CreditCardInfo;
}

export class RegisterLeadRequest implements IRegisterLeadRequest {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    creatorProfile: number;
    marketingSource: MarketingSource;

    constructor(data?: IRegisterLeadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.creatorProfile = _data["creatorProfile"];
            this.marketingSource = _data["marketingSource"] ? MarketingSource.fromJS(_data["marketingSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterLeadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterLeadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["creatorProfile"] = this.creatorProfile;
        data["marketingSource"] = this.marketingSource ? this.marketingSource.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegisterLeadRequest {
        const json = this.toJSON();
        let result = new RegisterLeadRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterLeadRequest {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    creatorProfile: number;
    marketingSource: MarketingSource;
}

export class AcquireAdditionalItemRequest implements IAcquireAdditionalItemRequest {
    id: string | undefined;
    quantity: number;

    constructor(data?: IAcquireAdditionalItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): AcquireAdditionalItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AcquireAdditionalItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        return data; 
    }

    clone(): AcquireAdditionalItemRequest {
        const json = this.toJSON();
        let result = new AcquireAdditionalItemRequest();
        result.init(json);
        return result;
    }
}

export interface IAcquireAdditionalItemRequest {
    id: string | undefined;
    quantity: number;
}

export class CheckoutRequest implements ICheckoutRequest {
    id: string | undefined;
    editionHash: string | undefined;
    buyer: Buyer;
    billingCycle: BillingCycle;
    numberOfInstallments: number;
    creditCard: CreditCard;
    address: AddressDto;
    discountVoucher: string | undefined;
    additionalItems: AdditionalItem[] | undefined;
    marketingSource: MarketingSource;

    constructor(data?: ICheckoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.editionHash = _data["editionHash"];
            this.buyer = _data["buyer"] ? Buyer.fromJS(_data["buyer"]) : <any>undefined;
            this.billingCycle = _data["billingCycle"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.creditCard = _data["creditCard"] ? CreditCard.fromJS(_data["creditCard"]) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.discountVoucher = _data["discountVoucher"];
            if (Array.isArray(_data["additionalItems"])) {
                this.additionalItems = [] as any;
                for (let item of _data["additionalItems"])
                    this.additionalItems.push(AdditionalItem.fromJS(item));
            }
            this.marketingSource = _data["marketingSource"] ? MarketingSource.fromJS(_data["marketingSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["editionHash"] = this.editionHash;
        data["buyer"] = this.buyer ? this.buyer.toJSON() : <any>undefined;
        data["billingCycle"] = this.billingCycle;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["creditCard"] = this.creditCard ? this.creditCard.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["discountVoucher"] = this.discountVoucher;
        if (Array.isArray(this.additionalItems)) {
            data["additionalItems"] = [];
            for (let item of this.additionalItems)
                data["additionalItems"].push(item.toJSON());
        }
        data["marketingSource"] = this.marketingSource ? this.marketingSource.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CheckoutRequest {
        const json = this.toJSON();
        let result = new CheckoutRequest();
        result.init(json);
        return result;
    }
}

export interface ICheckoutRequest {
    id: string | undefined;
    editionHash: string | undefined;
    buyer: Buyer;
    billingCycle: BillingCycle;
    numberOfInstallments: number;
    creditCard: CreditCard;
    address: AddressDto;
    discountVoucher: string | undefined;
    additionalItems: AdditionalItem[] | undefined;
    marketingSource: MarketingSource;
}

export class CheckoutResponse implements ICheckoutResponse {
    succeeded: boolean;
    errorCode: number;
    authenticateResultModel: AuthenticateResultModel;

    constructor(data?: ICheckoutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.errorCode = _data["errorCode"];
            this.authenticateResultModel = _data["authenticateResultModel"] ? AuthenticateResultModel.fromJS(_data["authenticateResultModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CheckoutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["errorCode"] = this.errorCode;
        data["authenticateResultModel"] = this.authenticateResultModel ? this.authenticateResultModel.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CheckoutResponse {
        const json = this.toJSON();
        let result = new CheckoutResponse();
        result.init(json);
        return result;
    }
}

export interface ICheckoutResponse {
    succeeded: boolean;
    errorCode: number;
    authenticateResultModel: AuthenticateResultModel;
}

export class GeneratePersonalizedLinkRequest implements IGeneratePersonalizedLinkRequest {
    linkAction: SubscriptionAction;
    editionId: string | undefined;
    discountVoucher: string | undefined;
    maxNumberOfInstallments: number | undefined;
    paymentMethod: PaymentMethod;
    trialDays: number | undefined;
    additionalItems: SelectedAdditionalItem[] | undefined;
    orderBump: OrderBump;

    constructor(data?: IGeneratePersonalizedLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkAction = _data["linkAction"];
            this.editionId = _data["editionId"];
            this.discountVoucher = _data["discountVoucher"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            this.paymentMethod = _data["paymentMethod"];
            this.trialDays = _data["trialDays"];
            if (Array.isArray(_data["additionalItems"])) {
                this.additionalItems = [] as any;
                for (let item of _data["additionalItems"])
                    this.additionalItems.push(SelectedAdditionalItem.fromJS(item));
            }
            this.orderBump = _data["orderBump"] ? OrderBump.fromJS(_data["orderBump"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneratePersonalizedLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePersonalizedLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkAction"] = this.linkAction;
        data["editionId"] = this.editionId;
        data["discountVoucher"] = this.discountVoucher;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        data["paymentMethod"] = this.paymentMethod;
        data["trialDays"] = this.trialDays;
        if (Array.isArray(this.additionalItems)) {
            data["additionalItems"] = [];
            for (let item of this.additionalItems)
                data["additionalItems"].push(item.toJSON());
        }
        data["orderBump"] = this.orderBump ? this.orderBump.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GeneratePersonalizedLinkRequest {
        const json = this.toJSON();
        let result = new GeneratePersonalizedLinkRequest();
        result.init(json);
        return result;
    }
}

export interface IGeneratePersonalizedLinkRequest {
    linkAction: SubscriptionAction;
    editionId: string | undefined;
    discountVoucher: string | undefined;
    maxNumberOfInstallments: number | undefined;
    paymentMethod: PaymentMethod;
    trialDays: number | undefined;
    additionalItems: SelectedAdditionalItem[] | undefined;
    orderBump: OrderBump;
}

export class GeneratePersonalizedLinkResponse implements IGeneratePersonalizedLinkResponse {
    url: string | undefined;
    edition: Edition;

    constructor(data?: IGeneratePersonalizedLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneratePersonalizedLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GeneratePersonalizedLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GeneratePersonalizedLinkResponse {
        const json = this.toJSON();
        let result = new GeneratePersonalizedLinkResponse();
        result.init(json);
        return result;
    }
}

export interface IGeneratePersonalizedLinkResponse {
    url: string | undefined;
    edition: Edition;
}

export class GetPaymentGatewayResponse implements IGetPaymentGatewayResponse {
    gateway: string | undefined;

    constructor(data?: IGetPaymentGatewayResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
        }
    }

    static fromJS(data: any): GetPaymentGatewayResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentGatewayResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        return data; 
    }

    clone(): GetPaymentGatewayResponse {
        const json = this.toJSON();
        let result = new GetPaymentGatewayResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentGatewayResponse {
    gateway: string | undefined;
}

export class GetSubscriptionBillingsResponse implements IGetSubscriptionBillingsResponse {
    due: SubscriptionActiveBilling[] | undefined;
    future: SubscriptionActiveBilling[] | undefined;

    constructor(data?: IGetSubscriptionBillingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["due"])) {
                this.due = [] as any;
                for (let item of _data["due"])
                    this.due.push(SubscriptionActiveBilling.fromJS(item));
            }
            if (Array.isArray(_data["future"])) {
                this.future = [] as any;
                for (let item of _data["future"])
                    this.future.push(SubscriptionActiveBilling.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSubscriptionBillingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionBillingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.due)) {
            data["due"] = [];
            for (let item of this.due)
                data["due"].push(item.toJSON());
        }
        if (Array.isArray(this.future)) {
            data["future"] = [];
            for (let item of this.future)
                data["future"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetSubscriptionBillingsResponse {
        const json = this.toJSON();
        let result = new GetSubscriptionBillingsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSubscriptionBillingsResponse {
    due: SubscriptionActiveBilling[] | undefined;
    future: SubscriptionActiveBilling[] | undefined;
}

export class GetSubscriptionResponse implements IGetSubscriptionResponse {
    customer: Customer;
    editionId: string | undefined;
    editionName: string | undefined;
    price: number;
    currentPrice: number;
    billingCycle: BillingCycle;
    startDate: Date;
    items: SubscriptionItem[] | undefined;
    status: SubscriptionStatus;
    activeBilling: { [key: string]: Date; } | undefined;

    constructor(data?: IGetSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.editionName = _data["editionName"];
            this.price = _data["price"];
            this.currentPrice = _data["currentPrice"];
            this.billingCycle = _data["billingCycle"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(SubscriptionItem.fromJS(item));
            }
            this.status = _data["status"] ? SubscriptionStatus.fromJS(_data["status"]) : <any>undefined;
            if (_data["activeBilling"]) {
                this.activeBilling = {} as any;
                for (let key in _data["activeBilling"]) {
                    if (_data["activeBilling"].hasOwnProperty(key))
                        (<any>this.activeBilling)[key] = _data["activeBilling"][key] ? new Date(_data["activeBilling"][key].toString()) : <any>undefined;
                }
            }
        }
    }

    static fromJS(data: any): GetSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["editionName"] = this.editionName;
        data["price"] = this.price;
        data["currentPrice"] = this.currentPrice;
        data["billingCycle"] = this.billingCycle;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        if (this.activeBilling) {
            data["activeBilling"] = {};
            for (let key in this.activeBilling) {
                if (this.activeBilling.hasOwnProperty(key))
                    (<any>data["activeBilling"])[key] = this.activeBilling[key] ? this.activeBilling[key].toISOString() : <any>undefined;
            }
        }
        return data; 
    }

    clone(): GetSubscriptionResponse {
        const json = this.toJSON();
        let result = new GetSubscriptionResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSubscriptionResponse {
    customer: Customer;
    editionId: string | undefined;
    editionName: string | undefined;
    price: number;
    currentPrice: number;
    billingCycle: BillingCycle;
    startDate: Date;
    items: SubscriptionItem[] | undefined;
    status: SubscriptionStatus;
    activeBilling: { [key: string]: Date; } | undefined;
}

export class ValidateDiscountVoucherRequest implements IValidateDiscountVoucherRequest {
    editionId: string | undefined;
    voucher: string | undefined;

    constructor(data?: IValidateDiscountVoucherRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionId = _data["editionId"];
            this.voucher = _data["voucher"];
        }
    }

    static fromJS(data: any): ValidateDiscountVoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateDiscountVoucherRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["voucher"] = this.voucher;
        return data; 
    }

    clone(): ValidateDiscountVoucherRequest {
        const json = this.toJSON();
        let result = new ValidateDiscountVoucherRequest();
        result.init(json);
        return result;
    }
}

export interface IValidateDiscountVoucherRequest {
    editionId: string | undefined;
    voucher: string | undefined;
}

export class ValidateVoucherResponse implements IValidateVoucherResponse {
    isValid: boolean;
    discount: number;
    isPercentageDiscount: boolean;

    constructor(data?: IValidateVoucherResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.discount = _data["discount"];
            this.isPercentageDiscount = _data["isPercentageDiscount"];
        }
    }

    static fromJS(data: any): ValidateVoucherResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVoucherResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["discount"] = this.discount;
        data["isPercentageDiscount"] = this.isPercentageDiscount;
        return data; 
    }

    clone(): ValidateVoucherResponse {
        const json = this.toJSON();
        let result = new ValidateVoucherResponse();
        result.init(json);
        return result;
    }
}

export interface IValidateVoucherResponse {
    isValid: boolean;
    discount: number;
    isPercentageDiscount: boolean;
}

export class CreateOrderRequest implements ICreateOrderRequest {
    products: BillableProduct[] | undefined;
    paymentMethod: PaymentMethod;
    numberOfInstallments: number;
    creditCard: CreditCard;
    discountVoucher: string | undefined;

    constructor(data?: ICreateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(BillableProduct.fromJS(item));
            }
            this.paymentMethod = _data["paymentMethod"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.creditCard = _data["creditCard"] ? CreditCard.fromJS(_data["creditCard"]) : <any>undefined;
            this.discountVoucher = _data["discountVoucher"];
        }
    }

    static fromJS(data: any): CreateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["paymentMethod"] = this.paymentMethod;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["creditCard"] = this.creditCard ? this.creditCard.toJSON() : <any>undefined;
        data["discountVoucher"] = this.discountVoucher;
        return data; 
    }

    clone(): CreateOrderRequest {
        const json = this.toJSON();
        let result = new CreateOrderRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateOrderRequest {
    products: BillableProduct[] | undefined;
    paymentMethod: PaymentMethod;
    numberOfInstallments: number;
    creditCard: CreditCard;
    discountVoucher: string | undefined;
}

export class SubscriptionItem implements ISubscriptionItem {
    name: string | undefined;
    value: string | undefined;
    extra: boolean;
    oneTime: boolean;
    price: number | undefined;
    status: SubscriptionStatusCode;

    constructor(data?: ISubscriptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.extra = _data["extra"];
            this.oneTime = _data["oneTime"];
            this.price = _data["price"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SubscriptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["extra"] = this.extra;
        data["oneTime"] = this.oneTime;
        data["price"] = this.price;
        data["status"] = this.status;
        return data; 
    }

    clone(): SubscriptionItem {
        const json = this.toJSON();
        let result = new SubscriptionItem();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionItem {
    name: string | undefined;
    value: string | undefined;
    extra: boolean;
    oneTime: boolean;
    price: number | undefined;
    status: SubscriptionStatusCode;
}

export class SubscriptionStatus implements ISubscriptionStatus {
    code: SubscriptionStatusCode;
    date: Date | undefined;

    constructor(data?: ISubscriptionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data; 
    }

    clone(): SubscriptionStatus {
        const json = this.toJSON();
        let result = new SubscriptionStatus();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionStatus {
    code: SubscriptionStatusCode;
    date: Date | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class AvailableAdditionalItem implements IAvailableAdditionalItem {
    id: string | undefined;
    title: string | undefined;
    description: string | undefined;
    price: number;
    quantity: number;

    constructor(data?: IAvailableAdditionalItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): AvailableAdditionalItem {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableAdditionalItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        return data; 
    }

    clone(): AvailableAdditionalItem {
        const json = this.toJSON();
        let result = new AvailableAdditionalItem();
        result.init(json);
        return result;
    }
}

export interface IAvailableAdditionalItem {
    id: string | undefined;
    title: string | undefined;
    description: string | undefined;
    price: number;
    quantity: number;
}

export class AvailableAdditionalItemSection implements IAvailableAdditionalItemSection {
    code: string | undefined;
    feature: string | undefined;
    title: string | undefined;
    items: AvailableAdditionalItem[] | undefined;

    constructor(data?: IAvailableAdditionalItemSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.feature = _data["feature"];
            this.title = _data["title"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AvailableAdditionalItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailableAdditionalItemSection {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableAdditionalItemSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["feature"] = this.feature;
        data["title"] = this.title;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AvailableAdditionalItemSection {
        const json = this.toJSON();
        let result = new AvailableAdditionalItemSection();
        result.init(json);
        return result;
    }
}

export interface IAvailableAdditionalItemSection {
    code: string | undefined;
    feature: string | undefined;
    title: string | undefined;
    items: AvailableAdditionalItem[] | undefined;
}

export class GetPaymentInfoResult implements IGetPaymentInfoResult {
    ownerName: string | undefined;
    digits: string | undefined;

    constructor(data?: IGetPaymentInfoResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerName = _data["ownerName"];
            this.digits = _data["digits"];
        }
    }

    static fromJS(data: any): GetPaymentInfoResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentInfoResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerName"] = this.ownerName;
        data["digits"] = this.digits;
        return data; 
    }

    clone(): GetPaymentInfoResult {
        const json = this.toJSON();
        let result = new GetPaymentInfoResult();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentInfoResult {
    ownerName: string | undefined;
    digits: string | undefined;
}

export class AdditionalItem implements IAdditionalItem {
    id: string | undefined;
    quantity: number;

    constructor(data?: IAdditionalItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): AdditionalItem {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        return data; 
    }

    clone(): AdditionalItem {
        const json = this.toJSON();
        let result = new AdditionalItem();
        result.init(json);
        return result;
    }
}

export interface IAdditionalItem {
    id: string | undefined;
    quantity: number;
}

export class AddressDto implements IAddressDto {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    validated: boolean;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.formattedAddress = _data["formattedAddress"];
            this.reference = _data["reference"];
            this.complement = _data["complement"];
            this.number = _data["number"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.validated = _data["validated"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["formattedAddress"] = this.formattedAddress;
        data["reference"] = this.reference;
        data["complement"] = this.complement;
        data["number"] = this.number;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["validated"] = this.validated;
        return data; 
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    validated: boolean;
}

export class Buyer implements IBuyer {
    name: string | undefined;
    email: string | undefined;
    fiscalIdentifier: string | undefined;
    fixedPhone: string | undefined;
    mobilePhone: string | undefined;
    password: string | undefined;
    professionCode: number | undefined;

    constructor(data?: IBuyer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.fiscalIdentifier = _data["fiscalIdentifier"];
            this.fixedPhone = _data["fixedPhone"];
            this.mobilePhone = _data["mobilePhone"];
            this.password = _data["password"];
            this.professionCode = _data["professionCode"];
        }
    }

    static fromJS(data: any): Buyer {
        data = typeof data === 'object' ? data : {};
        let result = new Buyer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["fiscalIdentifier"] = this.fiscalIdentifier;
        data["fixedPhone"] = this.fixedPhone;
        data["mobilePhone"] = this.mobilePhone;
        data["password"] = this.password;
        data["professionCode"] = this.professionCode;
        return data; 
    }

    clone(): Buyer {
        const json = this.toJSON();
        let result = new Buyer();
        result.init(json);
        return result;
    }
}

export interface IBuyer {
    name: string | undefined;
    email: string | undefined;
    fiscalIdentifier: string | undefined;
    fixedPhone: string | undefined;
    mobilePhone: string | undefined;
    password: string | undefined;
    professionCode: number | undefined;
}

export class CreditCard implements ICreditCard {
    flag: string | undefined;
    token: string | undefined;
    number: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;
    securityCode: string | undefined;
    ownerName: string | undefined;

    constructor(data?: ICreditCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flag = _data["flag"];
            this.token = _data["token"];
            this.number = _data["number"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.securityCode = _data["securityCode"];
            this.ownerName = _data["ownerName"];
        }
    }

    static fromJS(data: any): CreditCard {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flag"] = this.flag;
        data["token"] = this.token;
        data["number"] = this.number;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["securityCode"] = this.securityCode;
        data["ownerName"] = this.ownerName;
        return data; 
    }

    clone(): CreditCard {
        const json = this.toJSON();
        let result = new CreditCard();
        result.init(json);
        return result;
    }
}

export interface ICreditCard {
    flag: string | undefined;
    token: string | undefined;
    number: string | undefined;
    expirationMonth: string | undefined;
    expirationYear: string | undefined;
    securityCode: string | undefined;
    ownerName: string | undefined;
}

export class MarketingSource implements IMarketingSource {
    source: string | undefined;
    medium: string | undefined;
    campaign: string | undefined;
    content: string | undefined;

    constructor(data?: IMarketingSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.medium = _data["medium"];
            this.campaign = _data["campaign"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): MarketingSource {
        data = typeof data === 'object' ? data : {};
        let result = new MarketingSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["medium"] = this.medium;
        data["campaign"] = this.campaign;
        data["content"] = this.content;
        return data; 
    }

    clone(): MarketingSource {
        const json = this.toJSON();
        let result = new MarketingSource();
        result.init(json);
        return result;
    }
}

export interface IMarketingSource {
    source: string | undefined;
    medium: string | undefined;
    campaign: string | undefined;
    content: string | undefined;
}

export class OrderBump implements IOrderBump {
    items: string[] | undefined;
    paymentMethod: PaymentMethod;
    maxNumberOfInstallments: number;
    discountVoucher: string | undefined;
    price: number;
    discount: number;

    constructor(data?: IOrderBump) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(item);
            }
            this.paymentMethod = _data["paymentMethod"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            this.discountVoucher = _data["discountVoucher"];
            this.price = _data["price"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): OrderBump {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBump();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["paymentMethod"] = this.paymentMethod;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        data["discountVoucher"] = this.discountVoucher;
        data["price"] = this.price;
        data["discount"] = this.discount;
        return data; 
    }

    clone(): OrderBump {
        const json = this.toJSON();
        let result = new OrderBump();
        result.init(json);
        return result;
    }
}

export interface IOrderBump {
    items: string[] | undefined;
    paymentMethod: PaymentMethod;
    maxNumberOfInstallments: number;
    discountVoucher: string | undefined;
    price: number;
    discount: number;
}

export class SelectedAdditionalItem implements ISelectedAdditionalItem {
    id: string | undefined;
    quantity: number;
    price: number;
    section: string | undefined;
    title: string | undefined;
    unit: number;

    constructor(data?: ISelectedAdditionalItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.section = _data["section"];
            this.title = _data["title"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): SelectedAdditionalItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedAdditionalItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["section"] = this.section;
        data["title"] = this.title;
        data["unit"] = this.unit;
        return data; 
    }

    clone(): SelectedAdditionalItem {
        const json = this.toJSON();
        let result = new SelectedAdditionalItem();
        result.init(json);
        return result;
    }
}

export interface ISelectedAdditionalItem {
    id: string | undefined;
    quantity: number;
    price: number;
    section: string | undefined;
    title: string | undefined;
    unit: number;
}

export class AnnualPrice implements IAnnualPrice {
    installment: number;
    once: number;

    constructor(data?: IAnnualPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.installment = _data["installment"];
            this.once = _data["once"];
        }
    }

    static fromJS(data: any): AnnualPrice {
        data = typeof data === 'object' ? data : {};
        let result = new AnnualPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["installment"] = this.installment;
        data["once"] = this.once;
        return data; 
    }

    clone(): AnnualPrice {
        const json = this.toJSON();
        let result = new AnnualPrice();
        result.init(json);
        return result;
    }
}

export interface IAnnualPrice {
    installment: number;
    once: number;
}

export class Edition implements IEdition {
    id: string | undefined;
    code: string | undefined;
    annualId: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    allowBuy: boolean;
    price: EditionPrice;
    allowApplyDiscountVoucher: boolean;
    billingCycle: BillingCycle;
    highlights: EditionHighlight[] | undefined;
    extraHighlights: string[] | undefined;
    features: { [key: string]: string; } | undefined;
    trialDays: number;
    numberOfInstallments: number | undefined;
    maxNumberOfInstallments: number | undefined;
    paymentMethod: PaymentMethod;
    additionalItems: SelectedAdditionalItem[] | undefined;
    orderBump: OrderBump;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.annualId = _data["annualId"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.allowBuy = _data["allowBuy"];
            this.price = _data["price"] ? EditionPrice.fromJS(_data["price"]) : <any>undefined;
            this.allowApplyDiscountVoucher = _data["allowApplyDiscountVoucher"];
            this.billingCycle = _data["billingCycle"];
            if (Array.isArray(_data["highlights"])) {
                this.highlights = [] as any;
                for (let item of _data["highlights"])
                    this.highlights.push(EditionHighlight.fromJS(item));
            }
            if (Array.isArray(_data["extraHighlights"])) {
                this.extraHighlights = [] as any;
                for (let item of _data["extraHighlights"])
                    this.extraHighlights.push(item);
            }
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
            this.trialDays = _data["trialDays"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.maxNumberOfInstallments = _data["maxNumberOfInstallments"];
            this.paymentMethod = _data["paymentMethod"];
            if (Array.isArray(_data["additionalItems"])) {
                this.additionalItems = [] as any;
                for (let item of _data["additionalItems"])
                    this.additionalItems.push(SelectedAdditionalItem.fromJS(item));
            }
            this.orderBump = _data["orderBump"] ? OrderBump.fromJS(_data["orderBump"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["annualId"] = this.annualId;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["allowBuy"] = this.allowBuy;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["allowApplyDiscountVoucher"] = this.allowApplyDiscountVoucher;
        data["billingCycle"] = this.billingCycle;
        if (Array.isArray(this.highlights)) {
            data["highlights"] = [];
            for (let item of this.highlights)
                data["highlights"].push(item.toJSON());
        }
        if (Array.isArray(this.extraHighlights)) {
            data["extraHighlights"] = [];
            for (let item of this.extraHighlights)
                data["extraHighlights"].push(item);
        }
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = this.features[key];
            }
        }
        data["trialDays"] = this.trialDays;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["maxNumberOfInstallments"] = this.maxNumberOfInstallments;
        data["paymentMethod"] = this.paymentMethod;
        if (Array.isArray(this.additionalItems)) {
            data["additionalItems"] = [];
            for (let item of this.additionalItems)
                data["additionalItems"].push(item.toJSON());
        }
        data["orderBump"] = this.orderBump ? this.orderBump.toJSON() : <any>undefined;
        return data; 
    }

    clone(): Edition {
        const json = this.toJSON();
        let result = new Edition();
        result.init(json);
        return result;
    }
}

export interface IEdition {
    id: string | undefined;
    code: string | undefined;
    annualId: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    allowBuy: boolean;
    price: EditionPrice;
    allowApplyDiscountVoucher: boolean;
    billingCycle: BillingCycle;
    highlights: EditionHighlight[] | undefined;
    extraHighlights: string[] | undefined;
    features: { [key: string]: string; } | undefined;
    trialDays: number;
    numberOfInstallments: number | undefined;
    maxNumberOfInstallments: number | undefined;
    paymentMethod: PaymentMethod;
    additionalItems: SelectedAdditionalItem[] | undefined;
    orderBump: OrderBump;
}

export class EditionFeature implements IEditionFeature {
    id: string | undefined;
    title: string | undefined;
    hint: string | undefined;

    constructor(data?: IEditionFeature) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.hint = _data["hint"];
        }
    }

    static fromJS(data: any): EditionFeature {
        data = typeof data === 'object' ? data : {};
        let result = new EditionFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["hint"] = this.hint;
        return data; 
    }

    clone(): EditionFeature {
        const json = this.toJSON();
        let result = new EditionFeature();
        result.init(json);
        return result;
    }
}

export interface IEditionFeature {
    id: string | undefined;
    title: string | undefined;
    hint: string | undefined;
}

export class EditionHighlight implements IEditionHighlight {
    id: number | undefined;
    text: string | undefined;
    highlights: string[] | undefined;

    constructor(data?: IEditionHighlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            if (Array.isArray(_data["highlights"])) {
                this.highlights = [] as any;
                for (let item of _data["highlights"])
                    this.highlights.push(item);
            }
        }
    }

    static fromJS(data: any): EditionHighlight {
        data = typeof data === 'object' ? data : {};
        let result = new EditionHighlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        if (Array.isArray(this.highlights)) {
            data["highlights"] = [];
            for (let item of this.highlights)
                data["highlights"].push(item);
        }
        return data; 
    }

    clone(): EditionHighlight {
        const json = this.toJSON();
        let result = new EditionHighlight();
        result.init(json);
        return result;
    }
}

export interface IEditionHighlight {
    id: number | undefined;
    text: string | undefined;
    highlights: string[] | undefined;
}

export class EditionPrice implements IEditionPrice {
    annual: AnnualPrice;
    monthly: number;

    constructor(data?: IEditionPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.annual = _data["annual"] ? AnnualPrice.fromJS(_data["annual"]) : <any>undefined;
            this.monthly = _data["monthly"];
        }
    }

    static fromJS(data: any): EditionPrice {
        data = typeof data === 'object' ? data : {};
        let result = new EditionPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annual"] = this.annual ? this.annual.toJSON() : <any>undefined;
        data["monthly"] = this.monthly;
        return data; 
    }

    clone(): EditionPrice {
        const json = this.toJSON();
        let result = new EditionPrice();
        result.init(json);
        return result;
    }
}

export interface IEditionPrice {
    annual: AnnualPrice;
    monthly: number;
}

export class EditionsDefinition implements IEditionsDefinition {
    popular: PopularEdition;
    editions: Edition[] | undefined;
    selectedEdition: Edition;
    selectedEditionHash: string | undefined;
    highlights: { [key: string]: string; } | undefined;
    features: FeatureSection[] | undefined;

    constructor(data?: IEditionsDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.popular = _data["popular"] ? PopularEdition.fromJS(_data["popular"]) : <any>undefined;
            if (Array.isArray(_data["editions"])) {
                this.editions = [] as any;
                for (let item of _data["editions"])
                    this.editions.push(Edition.fromJS(item));
            }
            this.selectedEdition = _data["selectedEdition"] ? Edition.fromJS(_data["selectedEdition"]) : <any>undefined;
            this.selectedEditionHash = _data["selectedEditionHash"];
            if (_data["highlights"]) {
                this.highlights = {} as any;
                for (let key in _data["highlights"]) {
                    if (_data["highlights"].hasOwnProperty(key))
                        (<any>this.highlights)[key] = _data["highlights"][key];
                }
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features.push(FeatureSection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["popular"] = this.popular ? this.popular.toJSON() : <any>undefined;
        if (Array.isArray(this.editions)) {
            data["editions"] = [];
            for (let item of this.editions)
                data["editions"].push(item.toJSON());
        }
        data["selectedEdition"] = this.selectedEdition ? this.selectedEdition.toJSON() : <any>undefined;
        data["selectedEditionHash"] = this.selectedEditionHash;
        if (this.highlights) {
            data["highlights"] = {};
            for (let key in this.highlights) {
                if (this.highlights.hasOwnProperty(key))
                    (<any>data["highlights"])[key] = this.highlights[key];
            }
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }

    clone(): EditionsDefinition {
        const json = this.toJSON();
        let result = new EditionsDefinition();
        result.init(json);
        return result;
    }
}

export interface IEditionsDefinition {
    popular: PopularEdition;
    editions: Edition[] | undefined;
    selectedEdition: Edition;
    selectedEditionHash: string | undefined;
    highlights: { [key: string]: string; } | undefined;
    features: FeatureSection[] | undefined;
}

export class FeatureSection implements IFeatureSection {
    title: string | undefined;
    items: EditionFeature[] | undefined;

    constructor(data?: IFeatureSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EditionFeature.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureSection {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FeatureSection {
        const json = this.toJSON();
        let result = new FeatureSection();
        result.init(json);
        return result;
    }
}

export interface IFeatureSection {
    title: string | undefined;
    items: EditionFeature[] | undefined;
}

export class PopularEdition implements IPopularEdition {
    monthly: string | undefined;
    annual: string | undefined;

    constructor(data?: IPopularEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthly = _data["monthly"];
            this.annual = _data["annual"];
        }
    }

    static fromJS(data: any): PopularEdition {
        data = typeof data === 'object' ? data : {};
        let result = new PopularEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthly"] = this.monthly;
        data["annual"] = this.annual;
        return data; 
    }

    clone(): PopularEdition {
        const json = this.toJSON();
        let result = new PopularEdition();
        result.init(json);
        return result;
    }
}

export interface IPopularEdition {
    monthly: string | undefined;
    annual: string | undefined;
}

export class BillableProduct implements IBillableProduct {
    id: string | undefined;
    quantity: number;
    price: number;

    constructor(data?: IBillableProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): BillableProduct {
        data = typeof data === 'object' ? data : {};
        let result = new BillableProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        return data; 
    }

    clone(): BillableProduct {
        const json = this.toJSON();
        let result = new BillableProduct();
        result.init(json);
        return result;
    }
}

export interface IBillableProduct {
    id: string | undefined;
    quantity: number;
    price: number;
}

export class Address implements IAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    readonly text: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postalCode = _data["postalCode"];
            this.formattedAddress = _data["formattedAddress"];
            this.reference = _data["reference"];
            this.complement = _data["complement"];
            this.number = _data["number"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            (<any>this).text = _data["text"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postalCode"] = this.postalCode;
        data["formattedAddress"] = this.formattedAddress;
        data["reference"] = this.reference;
        data["complement"] = this.complement;
        data["number"] = this.number;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["text"] = this.text;
        return data; 
    }

    clone(): Address {
        const json = this.toJSON();
        let result = new Address();
        result.init(json);
        return result;
    }
}

export interface IAddress {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: string | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    text: string | undefined;
}

export enum BillingCycle {
    _1 = 1,
    _2 = 2,
}

export enum PaymentMethod {
    _0 = 0,
    _3 = 3,
    _10 = 10,
    __1 = -1,
}

export enum SubscriptionStatusCode {
    _0 = 0,
    _1 = 1,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _71 = 71,
}

export enum SubscriptionAction {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SubscriptionActiveBilling implements ISubscriptionActiveBilling {
    dueDate: Date;
    price: number;
    paymentLink: string | undefined;

    constructor(data?: ISubscriptionActiveBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.price = _data["price"];
            this.paymentLink = _data["paymentLink"];
        }
    }

    static fromJS(data: any): SubscriptionActiveBilling {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionActiveBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["price"] = this.price;
        data["paymentLink"] = this.paymentLink;
        return data; 
    }

    clone(): SubscriptionActiveBilling {
        const json = this.toJSON();
        let result = new SubscriptionActiveBilling();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionActiveBilling {
    dueDate: Date;
    price: number;
    paymentLink: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}